export default "__VITE_ASSET__C4vlkq6V__"